import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { objectToQuery } from 'helpers/Formatter';
import { showSuccess, showFailure } from 'actions/notificationActions';
import { generateOAuthUserToken } from 'actions/companyDetailsActions';
import { colors } from 'helpers/ColorHelper';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import stripeConfig from 'config/services/stripe';

const style = {
  badge: {
    textAlign: 'center',
    fontSize: '11px',
    lineHeight: '15px',
    borderRadius: '3px',
    color: '#fff',
    display: 'inline-block',
    padding: '1px 6px',
    marginBottom: '5px',
  },
};

class ConnectSetup extends React.Component {
  UNSAFE_componentWillMount() {
    const params = browserHistory.getCurrentLocation().query;
    if (!params.stripe_connected) return;

    if (params.stripe_connected === 'true') {
      this.props.showSuccess('successfullyConnectedStripe');
    } else if (params.stripe_connected === 'false') {
      this.props.showFailure('couldNotConnectToStripe');
    }

    browserHistory.push(browserHistory.getCurrentLocation().pathname);
  }

  _redirectToAuth = async () => {
    const response = await this.props.generateOAuthUserToken();
    if (!response.value) return;

    const { oauth_route, api, ...params } = stripeConfig;
    const url =
      oauth_route +
      objectToQuery({
        ...params,
        state: `${response.value.token};${this.props.propertyUniqueId}`,
      });

    window.location.assign(url);
  };

  render() {
    return (
      <div>
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-xs-12" style={{ padding: 0 }}>
            <h4
              style={{
                textAlign: 'center',
                backgroundColor: colors.LIGHT_GRAY,
                padding: '5px',
              }}
            >
              Banking Information
            </h4>
          </div>
        </div>

        <div className="row" style={{ textAlign: 'left' }}>
          {!this.props.stripeConnected ? (
            <div className="col-xs-12">
              <div className="row" style={{ margin: '5px 0 5px 0' }}>
                <p style={{ margin: 0, textAlign: 'center' }}>
                  Connect your account with our third-party payment processor (Stripe). This allows
                  you to securely accept credit card payments for services sold through your{' '}
                  <TenantResidentVerbiageHelper /> portal such as amenities, guest parking and
                  monthly rent.
                </p>
              </div>
              <div className="row" style={{ textAlign: 'center' }}>
                <span className="pending" style={style.badge}>
                  Stripe is inactive
                </span>
              </div>
              <div className="row">
                <h5 style={{ textAlign: 'center', marginTop: '20px' }}>
                  <button type="button" className="link-button" onClick={this._redirectToAuth}>
                    Click to Connect Account
                  </button>
                </h5>
              </div>
            </div>
          ) : (
            <div className="col-xs-12" style={{ margin: '5px 0 5px 0' }}>
              {/* TODO: Show brief summary of Stripe details here */}
              <p style={{ margin: '0 0 5px 0', textAlign: 'center' }}>
                Successfully connected with third-party payment processor.
              </p>
              <div className="row" style={{ textAlign: 'center' }}>
                <span className="closed" style={style.badge}>
                  Stripe is active
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(null, {
  showSuccess,
  showFailure,
  generateOAuthUserToken,
})(ConnectSetup);
